import { render } from "./StartInputBar.vue?vue&type=template&id=75cfcd7c&scoped=true"
import script from "./StartInputBar.vue?vue&type=script&lang=js"
export * from "./StartInputBar.vue?vue&type=script&lang=js"

import "./StartInputBar.vue?vue&type=style&index=0&id=75cfcd7c&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-75cfcd7c"]])

export default __exports__